import { FC } from 'react'
import styled from 'styled-components'
import { WasteType } from '../../../core/domain/models'
import WasteFilterItem from './WasteFilterItem'

interface WasteTypeGridProps {
  wasteTypes: WasteType[]
  onSelect: (id: string) => void
  selectedWasteTypes: Array<string>
}

const WasteTypeGrid: FC<WasteTypeGridProps> = ({ wasteTypes, selectedWasteTypes, onSelect }) => {
  return (
    <Container>
      <Grid>
        {wasteTypes.map((waste, index) => {
          return (
            <WasteFilterItem
              key={index}
              name={waste.name}
              id={waste.id}
              picture={waste.picture}
              onClick={onSelect}
              selected={selectedWasteTypes.includes(waste.id)}
            />
          )
        })}
      </Grid>
    </Container>
  )
}

const Container = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  overflow: auto;
  width: 100%;
  flex: 1;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 19px;
`

export default WasteTypeGrid
